import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { preferenceOptionsInitialState } from './state';
import { IPreferenceOptionItem, IPreferenceOptions } from 'v3/data/store/preferenceOptions/types';

export const preferenceOptionsSlice = createSlice({
  name: 'preferenceOption',
  initialState: preferenceOptionsInitialState,
  reducers: {
    setPreferenceOptionList: (state, action: PayloadAction<IPreferenceOptionItem[]>) => {
      state.preferenceOptions = action.payload;
      return state;
    },
  },
});
